import { render } from "./ChatMenuIcon.vue?vue&type=template&id=03d6fb10"
import script from "./ChatMenuIcon.vue?vue&type=script&lang=js"
export * from "./ChatMenuIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__